// extracted by mini-css-extract-plugin
export var parcelRow = "_tt-0";